import classes from "./login_page.module.css";
import GoogleButton from "../UI/google_signin_button/google_button";
import openGoogleLogin from "../../common/openGoogleLogin";

const LoginPage = () => {
  const handleGoogleLogin = async () => {
    try {
      await openGoogleLogin();
    } catch (error) {
      console.error('Google login failed:', error);
      // Silently handle the error to prevent breaking the UI
    }
  };

  return (
    <div className={classes.authPage}>
      <div className={classes.loginContainer}>
        <div className={classes.content}> {/* Add this div with the content class */}
          <h1 className={classes['welcome-back-text']} data-testid="welcome-heading">Welcome to ClassGenius!</h1>
          <GoogleButton
            handleButtonClick={handleGoogleLogin}
            data-testid="google-login-button"
          />
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
